export default __webpack_public_path__ + "static/media/8825.d94feacf.svg";